import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import * as selectors from '../../selectors';
const IntlHelmet = ({ titleMessage, descriptionMessage, children })=>{
    const direction = useSelector(selectors.direction);
    const locale = useSelector(selectors.locale);
    const { formatMessage } = useIntl();
    return /*#__PURE__*/ _jsxs(Helmet, {
        titleTemplate: "%s",
        htmlAttributes: {
            lang: locale,
            dir: direction
        },
        children: [
            titleMessage && /*#__PURE__*/ _jsx("title", {
                children: formatMessage(titleMessage)
            }),
            descriptionMessage && /*#__PURE__*/ _jsx("meta", {
                name: "description",
                content: formatMessage(descriptionMessage)
            }),
            children
        ]
    });
};
export default IntlHelmet;
